import './scss/style.scss'

import './components/gridtabs/index.js'
import './js/header.js'

jQuery(()=>{
  jQuery.getScript('http://localhost:35729/livereload.js');
})



// WEBPACK FOOTER //
// ./main.js